<div class="edit-profile-dialog-content no-close-btn-header d-flex flex-row"
  [ngClass]="{'edit-resume-popup': ctrl === 'PROFILE_ADD_EDU'}">
  <div class="popup-column-group profile-photo-video-column">
    <div class="column-title">Education</div>
    <div class="photo-video-ui">
      <div class="photo-video-container">
        <div class="profile-video-ui-wrapper">
          <video (loadeddata)="positionVideo()" id="vidPreview" [hidden]="!videoSelected"
          [src]="selectedVideoUrl" autoplay loop muted playsinline></video>
        </div>
        <img id="imgPreview" [hidden]="videoSelected" class="imgPreview" height="100%" src="{{selectedPhoto}}">
        <img [hidden]="photoSelected || videoSelected" class="noProfilePhoto_img" width="100%" height="100%"
          src="../../../../assets/images/default-profile-picture-new.svg">
          <div class="ui-popover openToggler">
            <button id="muteBtn" [hidden]="!videoSelected" (click)="muted(!muteClassAdd)"
              class="item-video-sound-control" [ngClass]="{'mute' : muteClassAdd}">
            <img class="audio-control-icon-img mute-icon"
              src="../../../../assets/images/sound-muted-icon.png"
              srcset="../../../../assets/images/sound-muted-icon@2x.png 2x, ../../../../assets/images/sound-muted-icon@3x.png 3x">
              <img class="audio-control-icon-img sound-icon"
                src="../../../../assets/images/sound-unmuted-icon.png"
                srcset="../../../../assets/images/sound-unmuted-icon@2x.png 2x, ../../../../assets/images/sound-unmuted-icon@3x.png 3x">
              </button>
            </div>
          </div>
          <div ngbDropdown class="camera-menu dropdown">
            <button ngbDropdownToggle class="btn dropdown-toggle" type="button" id="cameraMenuDropdown">
              <img src="../../../../assets/images/profile-camera-icon.png"
                srcset="../../../../assets/images/profile-camera-icon@2x.png 2x, ../../../../assets/images/profile-camera-icon@3x.png 3x"
                class="profile-camera-icon">
            </button>
            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right" aria-labelledby="cameraMenuDropdown">
              <a ngbDropdownItem (click)="recordVideo()" (keydown.enter)="recordVideo()" class="dropdown-item">Take a Video</a>
			  <a ngbDropdownItem (click)="removeVideo()" (keydown.enter)="removeVideo()" class="dropdown-item">Delete Video</a>
            </div>
          </div>
        </div>
        <div class="photo-video-hint">
          Record a short video describing your field of study, academic achievements, extracurricular activities, and experiences from your time at this institution.
        </div>
      </div>
      <div class="popup-column-group form-container-column edit-profile-content">
        <div class="modal-header">
          <h4 class="modal-title" id="modal-title">Education</h4>
        </div>
        <div class="modal-body">
          <div class="required-legend"><span class="requiredAsterix">*</span> Required Information</div>
          <input type="hidden" [(ngModel)]="pageStatus" value="{{pageStatus}}" />
          <div class="unnanu-form-group-style-1 has-sussgestions-dropdown">
            <label class="unnanu-input-label-style-1">School<span class="requiredAsterix">*</span></label>
            <input inputRestriction="allChars" [ngClass]="{'error': showSchoolError}" (blur)="hideSchoolSuggestions()"
              maxlength="100" [(ngModel)]="school" type="" name="company"
              class="form-control unnanu-text-input-style-1" id="" value=""
              placeholder="Search or add school" [ngbTypeahead]="searchSchool"
              (selectItem)="schoolSelectedFn($event)" [resultTemplate]="rt" required (ngModelChange)="onChange($event)">
            <ng-template #rt let-r="result" let-t="term">
              <img [src]="(r.LogoUrl | logoUrl) || '../../../../assets/images/education-default.jpg'"
                (error)="$any($event.target).src='../../../../assets/images/education-default.jpg'"
                class="me-2" style="width:16px;height:16px;object-fit:contain;vertical-align:middle;">
              <ngb-highlight [result]="r.Name" [term]="t"></ngb-highlight>
            </ng-template>
            <label class="error" [hidden]="!showSchoolError">Enter School Name</label>
          </div>
          <div class="unnanu-form-group-style-1 has-sussgestions-dropdown">
            <label class="unnanu-input-label-style-1">Location<span class="requiredAsterix">*</span></label>
            <city-suggestion inputRestriction="noSpecialChars" [Joblocation]="true" [data]="data" [parentobj]="parentobj" [showCityError]="showCityError" (cityUpdated)="onChange($event)">
            </city-suggestion>
            <label [hidden]="!parentobj.showCityError" class="error">Enter a location.</label>
          </div>
          <div class="unnanu-form-group-style-1 has-sussgestions-dropdown">
            <label class="unnanu-input-label-style-1">Degree<span class="requiredAsterix">*</span></label>
            <input inputRestriction="allChars" [ngClass]="{'error': showDegreeError}" maxlength="100" [(ngModel)]="degree"
              type="" name="" class="form-control unnanu-text-input-style-1" id="" value=""
              placeholder="Search or add degree" (blur)="hideDegreeSuggestions()"
              [ngbTypeahead]="searchDegree" (selectItem)="degreeSelectedFn($event)" [resultTemplate]="rtDegree"
              [resultFormatter]="degreeFormatter" (ngModelChange)="onChange($event)">
            <ng-template #rtDegree let-r="result" let-t="term">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8a8a8a" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="me-2" style="vertical-align:middle;flex:0 0 auto;"><path d="M22 10v6"/><path d="M6 12.5V16c0 1 2.7 2.5 6 2.5s6-1.5 6-2.5v-3.5"/><path d="M12 3 2 8l10 5 10-5-10-5Z"/></svg>
              <ngb-highlight [result]="r.Name" [term]="t"></ngb-highlight>
            </ng-template>
            <label [hidden]="!showDegreeError" class="error">Enter a degree.</label>
          </div>
          <div class="unnanu-form-group-style-1 d-flex justify-content-between">
            <div class="field-of-study-wrapper has-sussgestions-dropdown">
              <label class="unnanu-input-label-style-1">Field of Study<span
              class="requiredAsterix">*</span></label>
              <input inputRestriction="allChars" [ngClass]="{'error': showFOSError}" maxlength="100" [(ngModel)]="fos"
                type="" name="" class="form-control unnanu-text-input-style-1" id="" value=""
                placeholder="Search or add field of study" (blur)="hideFOSSuggestions()"
                [ngbTypeahead]="searchFos" (selectItem)="fosSelectedFn($event)" [resultTemplate]="rtFos"
                [resultFormatter]="fosFormatter" (ngModelChange)="onChange($event)">
            <ng-template #rtFos let-r="result" let-t="term">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8a8a8a" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="me-2" style="vertical-align:middle;flex:0 0 auto;"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2Z"/></svg>
              <ngb-highlight [result]="r.Name" [term]="t"></ngb-highlight>
            </ng-template>
              <label [hidden]="!showFOSError" class="error">Enter Field of Study</label>
            </div>
            <div class="">
              <label class="unnanu-input-label-style-1">GPA</label>
              <input [(ngModel)]="gpa" (keyup)="formatGPA()" type="number" maxlength="4" name="gpa"
                class="form-control unnanu-text-input-style-1" [ngClass]="{'error': showGPAError}" id=""
                value="" required (ngModelChange)="onChange($event)">
              <label class="error" [hidden]="!showGPAError">GPA is between 0 & 10</label>
              <label class="error" [hidden]="gpa>=0"> Leave ZERO or Enter GPA</label>
            </div>
          </div>
          <div class="unnanu-form-group-style-1">
            <label class="unnanu-input-label-style-1">Time Period<span class="requiredAsterix">*</span></label>
            <div class="time-duration-wrapper d-flex">
              <div class="duration-time has-month">
                <div class="month-year-group d-flex justify-content-between">
                  <div class="year">
                    <scroll-select class="periodMenu yearMenu" placeholder="Year" ariaLabel="Start year"
                      [options]="yearOptions" [value]="startYear"
                      (valueChange)="startYear = $event; onChange($event); validateTimePeriod()"></scroll-select>
                  </div>
                  <div class="month">
                    <scroll-select class="periodMenu yearMenu" placeholder="Month" ariaLabel="Start month"
                      [options]="monthOptions" [value]="startMonth.id"
                      (valueChange)="startMonth.id = $event; onChange($event); validateTimePeriod()"></scroll-select>
                  </div>
                </div>
                <div class="date-error-slot">
                  @if (startDateError) {
                    <label class="error">{{startDateErrorMessage}}</label>
                  }
                  @if (timePeriodError) {
                    <label class="error" style="font-size: 11px !important;">{{timePeriodErrorMessage}}</label>
                  }
                </div>
              </div>
              <div class="duration-to-label">-</div>
              <div class="duration-time duration-end-time has-month">
                <div class="month-year-group d-flex justify-content-between">
                  <div class="year">
                    <scroll-select class="periodMenu yearMenu" placeholder="Year" ariaLabel="End year"
                      [options]="endYearOptions" [value]="endYear"
                      (valueChange)="endYear = $event; onChange($event); validateTimePeriod()"></scroll-select>
                  </div>
                  <div class="month">
                    <scroll-select class="periodMenu yearMenu" placeholder="Month" ariaLabel="End month"
                      [options]="monthOptions" [value]="endMonth.id"
                      (valueChange)="endMonth.id = $event; onChange($event); validateTimePeriod()"></scroll-select>
                  </div>
                </div>
                <div class="date-error-slot">
                  @if (endDateError) {
                    <label class="error">{{endDateErrorMessage}}</label>
                  }
                </div>
              </div>
              <!-- End of the to time select dropdown -->
            </div>
            <div class="unnanu-form-group-style-1">
              <label class="unnanu-input-label-style-1">Description</label>
              <textarea [(ngModel)]="notes" rows="1" class="form-control unnanu-text-input-style-1"
              [ngClass]="{error: remaining() < 0}" maxlength="{{ maxLength }}" (ngModelChange)="onChange($event)"></textarea>
              @if (remaining() < 0) {
                <span>{{ remaining() }}</span>
              }
            </div>
          </div>
        </div>
        <div class="modal-footer text-right">
          <div class="footer-buttons-row d-flex justify-content-between align-items-center">
            @if (data.COGUID) {
              <button type="button" class="delete-card-button large float-left" (click)="deleteData()"
                >
                Delete
              </button>
            }
			@else {
				<button type="button" class="delete-card-button large float-left"
                  >

                </button>
			  }
			<div>
            <button type="button" class="cancel-changes-button large" (click)="close()">
              Cancel
            </button>
				<button type="button" class="save-changes-button large" [disabled]="!valueUpdated || !school.trim() || !degree.trim() || !fos.trim()
                    || !parentobj.city || startYear === 'Year:' || startMonth.id === '0'
                    || endYear === 'Year:' || endMonth.id === '0' || parentobj.showCityError
                    || hasToShowSchoolSuggestions || hasToShowDegreeSuggestions || hasToShowFOSSuggestions
                    || startDateError || endDateError || timePeriodError"
              (click)="saveData()">
              Save Changes
            </button>
		</div>
          </div>
        </div>
      </div>
    </div>
